
import Vue from 'vue'
import { api } from '@/scripts/api'
import { getData } from '@/scripts/data'
import { Cooks, IngredientGroups, Ingredients, SearchSelect, UnitGrams } from './entity/entity'
import { Route } from './entity/route'
export default Vue.extend({
  name: 'App',
  created: function () {
    api.getCookingData().then((res) => {
      if (res === 'error') {
        alert('Failed to load data! Please try again by refresh the page.')
        return
      }
      const data = getData(res)
      console.log(JSON.parse(JSON.stringify(data)))
      this.ingredients = data.ingredients
      this.ingredientGroups = data.ingredientGroups
      this.cooks = data.cooks
      this.searchByGenre = data.searchByGenre
      this.searchByIngredient = data.searchByIngredient
      this.searchByMethod = data.searchByMethod
      this.unitGrams = data.unitGrams
      this.loading = false
    })
  },
  data: function () : {
    loading: boolean,
    cooks: Cooks,
    ingredients: Ingredients,
    ingredientGroups: IngredientGroups,
    searchByIngredient: SearchSelect,
    searchByGenre: SearchSelect,
    searchByMethod: SearchSelect,
    unitGrams: UnitGrams,
    topLink: string,
    howToUseLink: string,
    publicPath: string
    } {
    return {
      loading: true,
      cooks: {},
      ingredients: {},
      ingredientGroups: {},
      searchByIngredient: {},
      searchByGenre: {},
      searchByMethod: {},
      unitGrams: {},
      topLink: Route.Top.path,
      howToUseLink: Route.HowToUse.path,
      publicPath: process.env.BASE_URL
    }
  },
  computed: {
    isTopPage: function () {
      return this.$route.path === Route.Top.path
    }
  },
  watch: {
    $route () {
      window.scrollTo(0, 0)
    }
  }
})
